import { BtcIcon, EthIcon, UsdcIcon, UsdtIcon } from "@src/icons"
import clsx from "clsx"

const classes = "size-8 shrink-0 rounded-full outline-2 outline-current"

const TokensNetworksPromo = ({ className }: { className?: string }) => (
  <div className={clsx("flex items-center gap-3", className)}>
    <div className="-space-x-2.5 flex">
      <BtcIcon className={classes} />
      <EthIcon className={classes} />
      <UsdtIcon className={classes} />
      <UsdcIcon className={classes} />
    </div>
    <p className="font-medium text-gray-400 text-sm/4.5">
      Receive 85+ assets
      <br /> across 35+ networks
    </p>
  </div>
)

export default TokensNetworksPromo
